const mutations = {
  SET_GEOGRAPHIC_BREAKDOWN(state, payload) {
    const countriesChart = payload && payload.topCountriesChart && payload.topCountriesChart.chart;
    const countriesData = payload && payload.topCountries;
    const countriesDate = payload && payload.topCountries && payload.topCountries[0] && payload.topCountries[0].DataAsOfDateFormatted;
    const currencyData = payload && payload.currency;
    const currencyDate = payload && payload.currency && payload.currency[0] && payload.currency[0].DataAsOfDateFormatted;
    const regionsData = payload && payload.regions;
    const regionsChart = payload && payload.regionsChart && payload.regionsChart.chart;
    const regionsDate = payload && payload.regions && payload.regions[0] && payload.regions[0].DataAsOfDateFormatted;

    state.geographicBreakdownData = {
      countriesChart,
      countriesData,
      countriesDate,
      currencyData,
      currencyDate,
      regionsChart,
      regionsData,
      regionsDate
    };
  }
};

const getters = {
  geographicBreakdownData: state => state.geographicBreakdownData
};

const state = {
  geographicBreakdownData: null
};

export default {
  state,
  mutations,
  getters
};
